/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {ASSET_ERROR} from '../../resources-constants';
import {ApiConfig} from '../../../api';
import {AdnHttpProgressCallback, AdnHttpService} from '../../../../util/adn-http.service';
import {AdnAssetHelperService} from '../../../../util/adn-asset-helper.service';
import {createAdnHttpUploadSender, createAdnUploadFormData} from '../../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../../app/common/directives/error/api-error-handler.service';



@Injectable({
  providedIn: 'root'
})
export class ReferenceDataService {
  private readonly sendUpload: (config: any, onProgress?: AdnHttpProgressCallback) => any;

  constructor(
    private readonly adnAssetHelper: AdnAssetHelperService,
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.sendUpload = createAdnHttpUploadSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  get(ids: any): any {
    ids = _.isArray(ids) ? ids : [ids];
    return this.adnAssetHelper.getAsJson('assets', {id: ids.join(';'), pageSize: ids.length});
  }

  fromCreative(id: any): any {
    return this.adnAssetHelper.fromParentAsJson('assets', id);
  }

  upload(data: any, uploadType?: any, onProgress?: AdnHttpProgressCallback): any {
    if (!data || !(data.file || data.content)) {
      return Promise.reject(ASSET_ERROR.NO_FILE);
    }
    return this.sendUpload({
      method: 'POST',
      url: ApiConfig.obtain().getVersionedUri([uploadType || 'categories', 'upload']),
      body: createAdnUploadFormData(data)
    }, onProgress);
  }
}
